// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.optionsList {
    position: relative;

    list-style: none outside none;
    margin: 0%;
    padding: 0em;
    text-indent: -0.5em;
    letter-spacing: 0.05em;

    transform: translate(-50%);

    height:fit-content;

    text-align: left;
    text-align: -moz-left;
}

.optionsList_Default {
    top: 23.0%;
    left: 72.5%;
}

.optionsList_GreyBars {
    top: 26.5%;
    left: 70%;
}

.optionsListItem {
    font: 5.0cqh MyriadPro-Semi;
    letter-spacing: 0.3cqh;

    line-height: 120%;

    color: black;

    text-transform: uppercase;
}

.optionsListItem span {
    position: relative;
    left: 1%;
}

.optionsListItem_GreyBar {
    font: bold 6.05cqh MyriadPro-Regular;
    /* line-height: 120%; */
    line-height: 40%;

    height:0%;

    color: black;
    margin: 0px 0px 0px 0px;

    text-transform: uppercase;
}

.optionsListItem_GreyBar div {
    position: relative;

    /* margin-top: -1.4%; */
    /* margin-bottom: 5cqh; */
    
    width: 60%;
    height: 4cqh;

    /* top: -5.4cqh; */
    left: 1%;

    transform: translate(0%, -60%);

    background-color: #cccaca;
}`, "",{"version":3,"sources":["webpack://./src/components/PackageDescriptions.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;;IAElB,6BAA6B;IAC7B,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;;IAEtB,0BAA0B;;IAE1B,kBAAkB;;IAElB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;;IAEtB,iBAAiB;;IAEjB,YAAY;;IAEZ,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,gBAAgB;;IAEhB,SAAS;;IAET,YAAY;IACZ,uBAAuB;;IAEvB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;;IAElB,uBAAuB;IACvB,yBAAyB;;IAEzB,UAAU;IACV,YAAY;;IAEZ,kBAAkB;IAClB,QAAQ;;IAER,8BAA8B;;IAE9B,yBAAyB;AAC7B","sourcesContent":[".optionsList {\r\n    position: relative;\r\n\r\n    list-style: none outside none;\r\n    margin: 0%;\r\n    padding: 0em;\r\n    text-indent: -0.5em;\r\n    letter-spacing: 0.05em;\r\n\r\n    transform: translate(-50%);\r\n\r\n    height:fit-content;\r\n\r\n    text-align: left;\r\n    text-align: -moz-left;\r\n}\r\n\r\n.optionsList_Default {\r\n    top: 23.0%;\r\n    left: 72.5%;\r\n}\r\n\r\n.optionsList_GreyBars {\r\n    top: 26.5%;\r\n    left: 70%;\r\n}\r\n\r\n.optionsListItem {\r\n    font: 5.0cqh MyriadPro-Semi;\r\n    letter-spacing: 0.3cqh;\r\n\r\n    line-height: 120%;\r\n\r\n    color: black;\r\n\r\n    text-transform: uppercase;\r\n}\r\n\r\n.optionsListItem span {\r\n    position: relative;\r\n    left: 1%;\r\n}\r\n\r\n.optionsListItem_GreyBar {\r\n    font: bold 6.05cqh MyriadPro-Regular;\r\n    /* line-height: 120%; */\r\n    line-height: 40%;\r\n\r\n    height:0%;\r\n\r\n    color: black;\r\n    margin: 0px 0px 0px 0px;\r\n\r\n    text-transform: uppercase;\r\n}\r\n\r\n.optionsListItem_GreyBar div {\r\n    position: relative;\r\n\r\n    /* margin-top: -1.4%; */\r\n    /* margin-bottom: 5cqh; */\r\n    \r\n    width: 60%;\r\n    height: 4cqh;\r\n\r\n    /* top: -5.4cqh; */\r\n    left: 1%;\r\n\r\n    transform: translate(0%, -60%);\r\n\r\n    background-color: #cccaca;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
